import { React } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as GoBackIcon } from "../../assets/svg/arrow_back_icon.svg";
import { userDashboardSelector } from "../../redux/userDashboard";
import { useSelector } from "react-redux";
import Loader from "../loader/Loader";

const LookingFor = ({ handleSelectPropertyType }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { allPropertyTypes } = useSelector(userDashboardSelector);

  return (
    <>
      <Box
        component="div"
        sx={{ width: "100%", textAlign: "left", padding: "16px 8px" }}
      >
        <Button
          sx={{
            border: "none !important",
            justifyContent: "left !important",
            height: "30px",
            backgroundColor: "none",
            width: "30px",
            filter:
              "invert(48%) sepia(0%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)",
          }}
          variant="xsSize"
          onClick={() => navigate("/my-property")}
        >
          <GoBackIcon />
        </Button>
      </Box>

      {allPropertyTypes?.loading && <Loader />}
      <Box sx={{ p: { xs: 2, md: 4 }, textAlign: "center" }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 600,
            color: "#1B2559",
            mb: 4,
            fontFamily: "Poppins, sans-serif",
            fontSize: { xs: "22px", md: "28px" },
          }}
        >
          {t("WhatAreaYouLookingFor.LookingFor")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: "340px", mx: "auto" }}>
          {allPropertyTypes?.items?.map((data, index) => (
            <Button
              key={index}
              variant="outlined"
              onClick={() => handleSelectPropertyType(data)}
              sx={{
                width: "100%",
                py: 1.5,
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                color: "#1B2559",
                borderColor: "#E8ECF0",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  borderColor: "#0085FD",
                  backgroundColor: "#F0F7FF",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(0, 133, 253, 0.1)",
                },
              }}
            >
              {data?.property_type}
            </Button>
          ))}
        </Box>
      </Box>
    </>
  );
};
export default LookingFor;
